import { UAParser } from 'ua-parser-js'
window.UAParser = UAParser
